import React, { useState } from 'react';
import axios from 'axios';
import './ChangePassword.css';

const API_BASE = '/api';

function ChangePassword() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (!current || !next) { setError('Please fill in all fields.'); return; }
    if (next !== confirm) { setError('New passwords do not match.'); return; }
    setBusy(true);
    try {
      await axios.post(`${API_BASE}/auth/change-password`,
        { current_password: current, new_password: next },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      setSuccess('Password changed successfully.');
      setCurrent(''); setNext(''); setConfirm('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to change password');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cp-page">
      <div className="cp-card">
        <h1>Change Password</h1>
        {error && <div className="cp-error">{error}</div>}
        {success && <div className="cp-success">{success}</div>}
        <form onSubmit={submit}>
          <div className="cp-field">
            <label>Current Password</label>
            <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" />
          </div>
          <div className="cp-field">
            <label>New Password</label>
            <input type="password" value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" />
          </div>
          <div className="cp-field">
            <label>Confirm New Password</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" />
          </div>
          <button className="cp-btn" disabled={busy}>{busy ? 'Saving…' : 'Change Password'}</button>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;
